import React, { useEffect } from 'react';
import ContactUsCard from '../../Components/ContactUsCard/ContactUsCard';
import CenterStage from '../../Components/CenterStage/CenterStage';
import ContactForm from '../ContactForm/ContactForm';
import AOS from 'aos';
import imgHANSAFLEX_Ireland_Contactlocation_Cover from '../../assets/ContactLocation/HANSAFLEX_Ireland_Contactlocation_Cover.webp';

import imgHANSAFLEX_Ireland_Contactlocation_IrelandDunmurry from '../../assets/ContactLocation/HANSAFLEX_Ireland_Contactlocation_IrelandDunmurry.webp'
import SectionHeader from '../../Components/SectionHeader/SectionHeader';

const ContactUs = () => {

    useEffect(() => {
        AOS.init();
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const units = [
        {
            name: 'HANSA-FLEX Ireland',
            location: '74 Derriaghy Industrial Park, BT17 9HU Dunmurry, Co. Antrim, Northern Ireland',
            telephone: '+44 028 90833813 (NI)',
            telephone2: '+353 01 6251962 (ROI)',
            mail: 'ni.info@hansa-flex.com',
            image: imgHANSAFLEX_Ireland_Contactlocation_IrelandDunmurry
        },



        // {
        //     name: 'HANSA-FLEX Dublin',
        //     location: "Parkwest Drive, 6 O'Casey Ave, West Industrial Park, Dublin 12, D12 WVO5, Ireland",
        //     telephone: '+353 1 625 1962',
        //     mail: 'ni.info@hansa-flex.com',
        //     image: imgGeorgiaGMBH
        // },

    ];

    return (
        <div className="">
            <div>
                <CenterStage
                    imageSrc={imgHANSAFLEX_Ireland_Contactlocation_Cover}
                    title={"Get in Touch with HANSA-FLEX Ireland"}
                    paragraph={"We're here to assist you with all your hydraulic needs. Whether you have inquiries about our products, require technical support, or wish to explore partnership opportunities, our team is ready to help. Contact us today and experience the reliability and expertise that define HANSA-FLEX Ireland."} />
            </div>

            <SectionHeader
                title={"Need a Hydraulic Solution? Let's Talk!"}
                paragraph={"Our experts in Ireland are ready to assist with tailored hydraulic services and components. Send us your enquiry now."}
            />

            {/* Two-column responsive layout */}
            <div className="container">
                <div className="row g-4 align-items-start">
                    {/* Left column: Card + Embedded Map */}
                    <div className="col-12 col-lg-6">
                        <ContactUsCard units={units} />

                        {/* Embedded Google Map below the card */}
                        {units && units.length > 0 && (
                            <div className="mt-3">
                                <div className="ratio ratio-16x9" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                    <iframe
                                        title="HANSA-FLEX Ireland Location Map"
                                        src={`https://www.google.com/maps?q=${encodeURIComponent('HANSA-FLEX ' + units[0].location)}&output=embed`}
                                        style={{ border: 0 }}
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Right column: Form */}
                    <div id="contact-form-section" className="col-12 col-lg-6" data-aos="fade-left">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
